export class PersonListFieldParameter {
  activeDirectories: string[] | undefined;
  employeeTypes: string[] | undefined;
  min: number | undefined;
  max: number | undefined;
}
